// Thrown when a request fails before getting an HTTP response — e.g. dropped
// connection, DNS failure, blocked by the user's network. Wraps the
// browser-specific TypeError that fetch() throws so Sentry fingerprints these
// failures consistently across browsers.
//
// `method` and `path` are carried because the Sentry reporting policy
// (isReportableError) treats a dropped mutation differently from a dropped
// read: see packages/app/api/errors.ts.
export class NetworkError extends Error {
  readonly method: string | undefined;

  readonly path: string | undefined;

  constructor(message: string, options: { cause?: unknown; method?: string; path?: string } = {}) {
    super(message, { cause: options.cause });
    this.name = 'NetworkError';
    this.method = options.method;
    this.path = options.path;
  }
}
